import React, { useRef, useEffect } from 'preact/compat';
import { ComponentChildren } from 'preact';
import { Field, useFormikContext } from 'formik';
import { SelfServiceFormValues } from '../../../lib/enquiry';
import { EnquiryType, enquiryTypeOptions } from '../../../lib/enquiry';
import ProductProblemFields from './product-problem';
import ProductEnquiryFields from './product-enquiry';
import * as Info from './info';
import FormError from '../error';
import { useSelfServiceFormContext } from './context';

export default function EnquiryFields() {
    const ref = useRef<HTMLDivElement>(null);
    const {
        classNames: {
            heading: headingClassName,
        },
    } = useSelfServiceFormContext();

    useEffect(() => {
        function handleChange(event: Event) {
            if (
                ref.current &&
                event.target instanceof HTMLInputElement &&
                event.target.name === 'enquiryType'
            ) {
                ref.current.scrollIntoView();
            }
        }

        if (ref.current) {
            ref.current.addEventListener('change', handleChange);
        }

        return () => {
            if (ref.current) {
                ref.current.removeEventListener('change', handleChange);
            }
        };
    }, [ref]);

    return (
        <div ref={ref} role='group' aria-labelledby='enquiry-fields-heading' className='form__section'>
            <div className='form__header'>
                <h2 id='enquiry-fields-heading' className={headingClassName}>
                    How can we help?
                </h2>
            </div>
            <ul className='toggle-list'>
                <EnquiryTypeOption type='productProblem'>
                    <ProductProblemFields />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='productEnquiry'>
                    <ProductEnquiryFields />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='whereToBuy'>
                    <Info.WhereToBuy />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='recipes'>
                    <Info.Recipes />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='tradeEnquiry'>
                    <Info.TradeEnquiry />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='workingWithUs'>
                    <Info.WorkingWithUs />
                </EnquiryTypeOption>
                <EnquiryTypeOption type='recycling'>
                    <Info.Recycling />
                </EnquiryTypeOption>
            </ul>
            <FormError name='enquiryType' />
        </div>
    );
}

function EnquiryTypeOption({ children, type }: EnquiryTypeOptionProps) {
    const {
        values: {
            enquiryType,
        },
    } = useFormikContext<SelfServiceFormValues>();

    return (
        <li className='toggle-list__item'>
            <label className='toggle-container'>
                <span className='toggle-container__input'>
                    <Field type='radio' name='enquiryType' value={type} className='toggle  toggle--radio' />
                </span>
                <span className='toggle-container__label'>
                    {enquiryTypeOptions[type]}
                </span>
            </label>
            {enquiryType === type && (
                <div className='toggle-list__reveal'>
                    {children}
                </div>
            )}
        </li>
    );
}

type EnquiryTypeOptionProps = {
    children?: ComponentChildren,
    type: EnquiryType,
};
